<template id="modal-template">
    <transition v-if="show" name="modal" appear>
        <div class="modal-container">
            <div class="modal-wrapper">
                <div class="modal modal--7">
                    <div class="modal__head">
                        <h1 class="modal__title">쿠폰사용</h1>
                        <button class="modal__close" type="button" @click="close">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <path d="M0.222,1.636 L1.636,0.221 L15.778,14.363 L14.364,15.778 L0.222,1.636 Z"/>
                                <path d="M14.364,0.221 L15.778,1.636 L1.636,15.778 L0.222,14.363 L14.364,0.221 Z"/>
                            </svg>
                        </button>
                    </div>
                    <div class="modal__body">
                        <!-- <div class="use-coupon-container">
                            <ul class="use-coupon__lists">
                                <li v-for="coupon in coupons" :key="coupon._id" class="use-coupon__list">
                                    <label class="check">
                                        <input v-model="selected" class="input" type="checkbox" name="coupons" :value="coupon">
                                        <i class="icon"></i>
                                        <span class="text">{{ coupon.name }}</span>
                                        <span class="num"><em>{{ coupon.amount.format() }}</em>{{ coupon.unit }}</span>
                                    </label>
                                </li>
                            </ul>
                        </div> -->
                        <div v-for="{ product, pickup, usableCoupons } in groups" :key="pickup._id">
                            <div>
                                <span>{{ `${product.name}(옵션: ${pickup.name}, ${pickup.quantity.format()}개)` }}</span>
                                <span>{{ `${$getSaleAmount(pickup).format()}원` }}</span>
                            </div>
                            <div>
                                <ul>
                                    <li v-for="coupon in usableCoupons" :key="coupon._id">
                                        <label>
                                            <input v-model="coupon.pickup" type="radio" :name="pickup._id" :value="pickup" :checked="coupon.pickup" @change="usableCoupons.forEach(usableCoupon => usableCoupon.pickup = usableCoupon._id == coupon._id ? usableCoupon.pickup : undefined)">
                                            <span>{{ coupon.name }}</span>
                                            <span>{{ `-${$getCouponAmount(coupon, $getSaleAmount(pickup)).format()}원` }}</span>
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <input type="radio" :name="pickup._id" :checked="!usableCoupons.find(coupon => coupon.pickup && coupon.pickup == pickup)" @click="usableCoupons.forEach(coupon => coupon.pickup = undefined)">
                                            <span>선택안함</span>
                                        </label>
                                    </li>
                                </ul>
                                <span></span>
                            </div>
                        </div>
                        <div>총 할인금액: {{ totalCouponAmount.format() }}원</div>
                    </div>
                    <div class="modal__foot modal__foot--border">
                        <div class="modal__buttons modal__buttons--narrow">
                            <button class="button button--border-primary" type="button" @click="close"><span>취소하기</span></button>
                            <button class="button button--primary" type="button" @click="confirm();"><span>쿠폰적용</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default{
    props: {
        value: { type: Array, default: null },
        coupons: { type: Array, default: null },
        carts: { type: Array, default: null },
    },
    data () {
        return {
            show: false,
            clone: []
        };
    },
    methods: {
        confirm(){
            this.coupons.forEach(coupon => coupon.pickup = (this.productCoupons.find(productCoupon => productCoupon._id == coupon._id) || {}).pickup  );
            this.$emit('input', this.productCoupons);
            this.close();
        },
        open(){
            this.show = true;
            this.clone = this.$props.coupons.reduce((clone, coupon) => clone.concat({ ...coupon }), []);
            document.querySelector('html').setAttribute('data-modal', 'opened');
        },
        close(){
            this.show = false;
			document.querySelector('html').removeAttribute('data-modal');
        },
    },
    computed: {
        groups(){
            return this.show ? this.carts.reduce((groups, cart) => {
                var product = cart.product;
                for(var pickup of cart.pickups){
                    var usableCoupons = [];

                    for(var coupon of this.clone){
                        if(coupon.type == "product" && product._id == coupon._product && coupon.minAmount < this.$getSaleAmount(pickup) ) usableCoupons.push(coupon);
                        if(coupon.type == "category" && [...product.category._parents, product._category].includes(coupon._category)  && coupon.minAmount < this.$getSaleAmount(pickup)) usableCoupons.push(coupon);
                    }
    
                    groups.push({
                        product,
                        pickup,
                        usableCoupons
                    });
                }

                return groups;
            }, []) : [];
        },
        productCoupons(){
            return this.clone.filter(coupon => coupon.pickup);
        },
        totalCouponAmount(){
            return this.productCoupons.reduce((totalCouponAmount, coupon) => totalCouponAmount + this.$getCouponAmount(coupon, this.$getSaleAmount(coupon.pickup)), 0);
        },
        payload(){
            return this.$store.state.payload || {};
        },
        scope(){
            return this.payload.scope || [];
        }
    }
}
</script>
